export interface ISystemAiFunction {
  id?: number;
  name?: string;
}

export const defaultValue: Readonly<ISystemAiFunction> = {};
